import client from './client'
import install from './install'

// 子模块
import login from './login'
import api from './api'
import apiAsync from './apiAsync'

/**
 * 管理端 登录验证
 * http://gitlab.yintech.net/spero/vision/backend/spero-author-service
 */
export default class AuthApi {
  constructor (options, vm) {
    if (AuthApi.instance) {
      throw new Error('AuthApi is singleton')
    }
    AuthApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.login = login
    this.api = api
    this.apiAsync = apiAsync
  }
  static getInstance () {
    return AuthApi.instance
  }
}

AuthApi.instance = null
AuthApi.install = install



// WEBPACK FOOTER //
// ./src/apis/auth-api/index.js